export const DefectTableFields = {
    DEFECT_ID: "formattedDefectId",
    PRIORITY: "priority",
    GRADING_AREA_FIELD: "gradingAreaField",
    DESCRIPTION: "description",
    RECOMMENDATIONS: "recommendations",
    ESTIMATE_DEFECT_COST_FIELD: "estimateDefectCostField",
    VESSEL_NAME: "vesselName",
    IMO: "vessel.imo",
    TYPE: "type",
    SUB_TYPE: "subType",
    INSPECTION_DATE_FILTER_FIELD: "inspectionDateFilterField",
    TECHNICAL_MANAGER: "technicalManager",
    NOTES: "notes",
    RECTIFICATION: "rectificationId",
    IDWAL_GRADE: "idwalGrade",
    STATUS: "status",
    EVIDENCE: "evidence",
    IMAGES: "images",
    CONTAINS_IMAGES: "containsImages",
    INSPECTION_DATE: "inspectionDate",
    INSPECTION_TYPE: "inspectionType",
    NAME_FILTER_FIELD: "nameFilterField",
    TYPE_CODE: "typeCode",
    SHORT_GEN_NAME: "shortGenName",
    ACTIONS: "actions"
};

export const DefectTableDefaultColumns = [
    DefectTableFields.INSPECTION_DATE,
    DefectTableFields.IMAGES,
    DefectTableFields.RECOMMENDATIONS,
    DefectTableFields.ESTIMATE_DEFECT_COST_FIELD,
    DefectTableFields.TYPE,
    DefectTableFields.IDWAL_GRADE,
    DefectTableFields.TECHNICAL_MANAGER,
    DefectTableFields.NOTES,
]